module.exports = __webpack_public_path__ + "static/media/9.3252f7b6.svg";